<template>
  <!-- 数据统计-抽奖统计 -->
  <div class="index">
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            size="small"
            v-model="query.id"
            placeholder="用户UID搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model="query.name"
            placeholder="用户名搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model="query.phone"
            placeholder="手机号码搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model="query.email"
            placeholder="邮箱搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <p class="prompt">默认展示当天数据</p>
    <div class="body-box">
      <el-table :data="dataList" @sort-change="handleSort" v-loading="loading">
        <el-table-column
          prop="id"
          label="箱子ID"
          width="100px"
          sortable="custom"
        ></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="price" label="盒子单价"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.status === 1">正常</el-tag>
            <el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
            <el-tag type="info" v-if="row.status === 3">补货中</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_number"
          label="抽奖次数"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="total_price"
          label="抽奖总额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="prize_total_price"
          label="奖品总额"
          sortable="custom"
        ></el-table-column>
        <el-table-column prop="probability" label="概率"></el-table-column>
        <el-table-column prop="winType" label="类型">
          <template slot-scope="{ row }">
            <el-tag v-if="row.winType === 1">欧皇盲盒</el-tag>
            <el-tag v-if="row.winType === 2">非酋盲盒</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300px">
          <template slot-scope="{ row }">
            <el-button type="primary" @click="getDetailData(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="visible" width="1000px">
      <el-table :data="detailList" show-summary>
        <el-table-column
          prop="id"
          label="饰品ID"
          width="100px"
        ></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="total_amount" label="抽奖总额"></el-table-column>
        <el-table-column prop="total_number" label="抽奖次数"></el-table-column>
        <el-table-column prop="sell_number" label="卖回数量"></el-table-column>
        <el-table-column
          prop="get_out_number"
          label="取出数量"
        ></el-table-column>
        <el-table-column
          prop="backpack_number"
          label="背包数量"
        ></el-table-column>
        <el-table-column prop="trade_amount" label="赠送数量"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import http, {
  getData,
  postData,
  patchData,
  server,
  api,
  postApiData,
  patchApiData,
  getApiData
} from '../../http'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      loadingDetail: false,
      dataList: undefined,
      detailList: undefined,
      dataMeta: {},
      query: {
        id: undefined,
        box_name: undefined,
        status: undefined,
        start_time: undefined,
        end_time: undefined,
        page: undefined,
        order_field: 'id',
        order_sort: 'desc'
      }
    }
  },
  computed: {
    ...mapState({
    }),
  },
  created() {
    this.getData(1)
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      getApiData('lottery_statistics', {
        ...this.query
      })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDetailData(row) {
      this.visible = true
      this.loadingDetail = true
      let params = {
        id: row.id,
        start_time: this.query.start_time,
        end_time: this.query.end_time
      }
      getApiData('lottery_statistics_detail', params)
        .then(res => {
          this.detailList = res
        })
        .finally(() => {
          this.loadingDetail = false
        })
    },
    getSummaries(param) {
      const {
        columns,
        data
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 元'
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    handleSort(column) {
      this.query.order_field = column.prop
      this.query.order_sort = column.order === 'ascending' ? 'asc' : 'desc'
      this.query.page = 1
      this.getData()
    },
  },
}

</script>

<style>
</style>
